// extracted by mini-css-extract-plugin
export var externalLink = "_ce-0";
export var internalLinkLabel = "_ce-1";